$(function () {

	var $body = $('body');

	//ページ内スクロール
	$.smooziee();

	//スクロールしたらクラスを付与
	$(window).scroll(function () {
		if ($(this).scrollTop() > 300) {
			$body.addClass("scroll");
		} else {
			$body.removeClass("scroll");
		}
	});

	// スクロールアニメーション
	new WOW().init();

	//ONLY HARIBIスライドショー
	var mySwiper = new Swiper('.only_swiper', {
		loop: true,
		// speed: 800,
		effect: 'slide',
		allowTouchMove: false,
		// slidesPerView: 1,
		autoplay: {
			delay: 1000,
		},
	});

	//ポップアップ
	$('.popup-modal-single').magnificPopup({
		type: 'inline',
		preloader: false,
		removalDelay: 300,
	});

	//閉じるリンクの設定
	$(document).on('click', '.btn_close', function (e) { 
		e.preventDefault();
		$.magnificPopup.close();
	});

	//学びスライドショー
	var mySwiper = new Swiper('.learning_swiper', {
		loop: true,
		centeredSlides: true,
		autoplay: {
			delay: 3000,
		},
		breakpoints: {
			320: {
				slidesPerView: 1.24,
				spaceBetween: 19,
			},
			// 768px以上の場合
			767: {
				slidesPerView: 1.66,
				// slidesPerView: 3.12,
				spaceBetween: 50,
			},
		},
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		}
	});

});